import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useInternalApi } from "../../../hooks/internal-api";
import { useLocale } from "../../../hooks/locale";
import { forgotPassword } from "./util";

export const useFinaliseAccount = () => {
	const passenger = useSelector((state) => state.passengers);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const booking = useSelector(
		(state) => state.bookings.recentlyCompletedBooking,
	);
	const { pathPrefix } = useLocale();

	const [showPasswordIcon, setShowPasswordIcon] = useState(false);
	const [showConfirmPasswordIcon, setShowConfirmPasswordIcon] = useState(false);
	const internalApi = useInternalApi();

	const updatePassword = (values) => {
		dispatch(
			forgotPassword(
				internalApi,
				values,
				passenger.email,
				booking.authProviderId,
			),
		).then(() => {
			navigate(`${pathPrefix}/bookings/${booking.reference}`);
		});
	};

	useEffect(() => {
		if (!booking) {
			navigate(`${pathPrefix}/`);
		}
	}, []);

	return {
		showPasswordIcon,
		setShowPasswordIcon,
		showConfirmPasswordIcon,
		setShowConfirmPasswordIcon,
		updatePassword,
	};
};
